module.exports = __webpack_public_path__ + "static/media/emma_poster.48b71717.png";